export default __webpack_public_path__ + "static/media/Ring of Profane Knowledge.2935affd.jpg";